import React from "react";
import parse from "html-react-parser";

import atob from "atob";

const PrintVisit = (props) => {
  const print_voucher = () => {
    var mywindow = window.open("", "PRINT", "height=400,width=900");

    mywindow.document.write(
      "<html><head><title>" + document.title + "</title>"
    );
    mywindow.document.write("</head><body >");

    mywindow.document.write(document.getElementById("voucher").innerHTML);
    mywindow.document.write("</body></html>");

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

    return true;
  };

  const { visit } = (props.location && props.location.state) || {};
  return (
    <div>
      <button className="btn btn-primary" onClick={() => print_voucher()}>
        Print
      </button>{" "}
      <div
        id="voucher"
        className="visitPrint"
        style={{ width: "350px", margin: "auto" }}
      >
        {parse(atob(visit.visit_pass))}
      </div>
    </div>
  );
};

export default PrintVisit;
